'use strict';

module.exports = [
  '$scope',
  '$contextMenu',
  ContextMultiController];

function ContextMultiController($scope, $contextMenu) {
  /*****************************************************************************************************************
   * Initialize
   ****************************************************************************************************************/
  var vm = $scope.selection = this;
  vm.count = 0;

  vm.openContextMenu = openContextMenu;


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function openContextMenu() {

  }

  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

}


// WEBPACK FOOTER //
// ./src/js/core-components/context-menu/ContextMultiController.js